import { render, staticRenderFns } from "./ChangeProfile.vue?vue&type=template&id=0ba3fdb9&"
import script from "./ChangeProfile.vue?vue&type=script&lang=js&"
export * from "./ChangeProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports